import { StanButton } from '@/components';
import { PageStatus } from '@/types/store';

interface PublishFooterProps {
    status: PageStatus;
    hasPendingChange: boolean;
    canPublish: boolean;
    canHide: boolean;
    isPublishing: boolean;
    isHiding: boolean;
    onPublish: () => void;
    onHide: () => void;
}

export const PublishFooter = ({
    status,
    hasPendingChange,
    canPublish,
    canHide,
    isPublishing,
    isHiding,
    onPublish,
    onHide,
}: PublishFooterProps) => (
    <div className='flex flex-col items-stretch gap-4 md:items-end'>
        {/* TODO: Add "Improve this page" feature */}
        {/* <p className='text-caption-1-regular text-light text-center md:text-right'>Improve this page</p> */}
        <div className='flex w-full flex-col-reverse items-stretch gap-3 md:w-auto md:flex-row md:items-center md:justify-end'>
            {status === PageStatus.PUBLISHED && (
                <StanButton
                    name='hide-funnel-page'
                    variant='outline'
                    onClick={onHide}
                    disabled={!canHide}
                    loading={isHiding}
                    className='w-full md:w-auto'
                >
                    Hide Page
                </StanButton>
            )}
            <StanButton
                name='publish-funnel-page'
                onClick={onPublish}
                disabled={!canPublish || (!hasPendingChange && status === PageStatus.PUBLISHED)}
                loading={isPublishing}
                className='w-full md:w-auto'
            >
                {getPublishButtonLabel(status, hasPendingChange)}
            </StanButton>
        </div>
    </div>
);

function getPublishButtonLabel(status: PageStatus, hasPendingChange: boolean): string {
    if (status !== PageStatus.PUBLISHED) return 'Publish Page';
    if (hasPendingChange) return 'Save Changes';
    return 'Published';
}
